const Address = {
  hausnummer: "",
  ort: "",
  plz: "",
  strasse: "",
};

export default Address;